import React, { Component } from 'react';
import { Link } from 'react-router';

import ExamService from '../services/ExamService';
import Paginate from './Paginate';
import EnarmUtil from '../modules/EnarmUtil';
import Materialize from 'materialize-css';

class CasoTable extends React.Component {

  constructor(props){
    super(props);
    this.state = {data:[
                      {
                        id:1,
                        name:"Caso clinico de prueba 1",
                        category_id:0
                      }
                      ],
                      categories:[]};
    this.page = this.getPage(props);
    this.itemsPerPage = 10;
  }

  componentDidMount() {
      ExamService.getExams()
      .then((response) => {
          this.setState({data : response.data});
      })
      .catch((error) => {
        console.log("ocurrio un erro",error);
      });
      let categories = EnarmUtil.getCategories()
      if(categories === null){
        ExamService.loadCategories()
        .then((response) => {
            EnarmUtil.setCategories(JSON.stringify(response.data));
            this.setState({categories:response.data});
        })
        .catch((error) => {
          console.log("ocurrio un error",error);
        })
      }else{
        categories = JSON.parse(categories);
        this.setState({categories:categories});
      }

      window.$('select').material_select();


  }

  paginateCases(page,amount){
      return this.state.data.filter(function(item, i) {
        return i >= amount*(page-1) && i < page*amount;
        });
  }

  getPage(props){
      let page = 1;
     if (!EnarmUtil.isEmpty(props.params)) {
        if(!isNaN(parseInt(props.params.page))){
          page = props.params.page;
        }
    }
    return page;
  }

  componentWillReceiveProps(nextProps) {
    var currentPage = this.getPage(nextProps);

    if(nextProps.location.action == "POP"){
          this.page = currentPage;
    }
  }

  changeCategory(caso,index,event){
    
    let realIndex = ((this.page-1)*this.itemsPerPage)+index;
    let category_id = parseInt(event.target.value);
    caso.category_id = category_id
    ExamService.saveCaso(caso)
    .then((response) => {
      window.Materialize.toast('Se actualizo la especialidad',1009);
      let casoUpdated = response.data;
      const casos = this.state.data;
      casos[realIndex] = casoUpdated;
      this.setState({data:casos});
    })
    .catch((error)=>{
      console.log("ocurrio un erro",error);
      window.Materialize.toast('No se pudo actualizar la especialidad',1009);
    })
  }

  render() {
    var especialidadesOptions = this.state.categories.map((especialidad, index)=>{
      return(
        <option value={especialidad.id} key={especialidad.id}>{especialidad.name}</option>
      )
    })
    var casos = this.paginateCases(this.page,this.itemsPerPage).map((caso,index) => {
        return (
          <li key={caso.id} className="row collection-item">
            <div>
            <div className="col m4 s12">
              <label>Especialidad</label>
                <select className="browser-default" value={caso.category_id} onChange={(event) => this.changeCategory(caso,index,event)} >
                  <option value="0" disabled>Selecciona una Especialidad</option>
                  {especialidadesOptions}
                </select></div>

              <div className="col m7 s12">{caso.description}</div>
              <Link to={"/edit/caso/"+caso.id} alt="ver preguntas" className="secondary-content">
              <i className="material-icons">edit</i>
            </Link>
          </div>
          </li> )
    });
      return(
      <div>
      <div className="fixed-action-btn">
      <Link to={"/new/caso"} alt="ver preguntas" className="btn-floating btn-large black" style={{top: '-5px'}}>
            <i className="material-icons right">add</i>

            </Link>
            </div>
      <div className="white">

      <ul className="collection with-header">
      <li className="collection-header">
          <h4>Casos Clinicos <span className="badge">({this.state.data.length})</span></h4>
                      <Paginate currentPage={this.page} items={this.state.data} itemsPerPage={this.itemsPerPage} />
        </li>
      {casos}
      </ul>
      <Paginate currentPage={this.page} items={this.state.data} itemsPerPage={this.itemsPerPage} />

      </div>
      </div>

      )
  }
}

export default CasoTable;



// WEBPACK FOOTER //
// ./src/components/CasoTable.js